shadow$provide[447] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform float splitStride;

vec2 getIndices(vec4 xyzw);
vec4 getRest(vec4 xyzw);
vec4 injectIndex(float v);

vec4 getSplitXYZW(vec4 xyzw) {
  vec2 uv = getIndices(xyzw);
  float offset = uv.x + uv.y * splitStride;
  return injectIndex(offset) + getRest(xyzw);
}
`;

};